export default {
    deviceRecentlySeen: [],
    recentlySeen: null,
    searchList: null,
    preferences: null,
    searchListIssued: null,
    recentlySeenIssued: null,
    postingCardsAnswers: false,
    cardsAnswersToPost: [],
    cards: [],
    cardsProgress: [],
    answersDailyLimit: false,
    favorites: [],
    favoritesIssued: null,
    triggerFavoritesChange: null,
    homeRecommendations: null,
}
